import FlowioSwitch from "./FlowioSwitch";

export default FlowioSwitch;
export type { FlowioSwitchProps } from "./FlowioSwitch";
